<script setup lang="ts">
import { computed } from "vue";
import { SvgIcon } from "../";

interface Props {
	label: 1 | 2 | 3 | 4 | 5;
	amount?: number;
	total?: number;
}
const { label, amount, total } = defineProps<Props>();

const width = computed(() => {
	if (!amount || !total) {
		return "0%";
	}
	return `${(amount / total) * 100}%`;
});
</script>

<template>
	<div class="flex gap-x-3 items-center text-base leading-7">
		<div class="flex items-center justify-between gap-x-1 w-8">
			<span class="font-bold">
				{{ label }}
			</span>
			<SvgIcon name="star" class="relative bottom-[2px]" />
		</div>
		<div class="flex w-[6.25rem]">
			<div
				class="h-1 bg-black-light"
				:style="{
					width
				}"
			/>
			<div class="h-1 grow bg-sand" />
		</div>
		<span>
			{{ amount }}
		</span>
	</div>
</template>
